<template>
  <div class="header">
    <div class="tryArea" v-if="showTry">
      <div class="tryIcon">试用中</div>
      <div class="tryText">试用 {{ failure_day }} 天后结束</div>
      <div class="serviceTel">商务合作：刘海龙&nbsp;&nbsp;13301399328</div>
    </div>
    <div class="header_content">
      <div class="header_left">
        <div class="header_logo">
          <img
            src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/logo_20221226.png"
          />
          
        </div>
      </div>
      <div style="min-width: 70px;"><a style="color: green; margin-left: -40px;" target="_blank" href="https://img.cy-cdn.com/cyresearch_report/%E4%B8%93%E9%A2%98%E6%8A%A5%E5%91%8A/%E8%BD%A6%E4%BA%91SAAS%E5%B9%B3%E5%8F%B0%E4%BD%BF%E7%94%A8%E6%8C%87%E5%AF%BC%E6%89%8B%E5%86%8C.pdf">使用手册</a></div>
      <div class="header_center">
        <router-link
          :to="{ path: '/home' }"
          class="link_tab"
          :class="platform == 'home' ? 'act' : ''"
          >首页</router-link
        >
        <router-link
          :to="{ path: '/rank/0' }"
          class="link_tab"
          :class="platform == 'cockpit' ? 'act' : ''"
          >智能座舱3.0</router-link
        >
        <router-link
          :to="{ path: '/v2/rank/0' }"
          class="link_tab"
          :class="platform == 'v2' ? 'act' : ''"
          >智能座舱4.0-5.0</router-link
        >
        <!-- <router-link
          :to="{ path: '/drive/rank/0' }"
          class="link_tab"
          :class="platform == 'drive' ? 'act' : ''"
          >智能驾驶</router-link
        > -->
        <router-link
          :to="{ path: '/service' }"
          class="link_tab"
          :class="platform == 'service' ? 'act' : ''"
          >工作台</router-link
        >
        <!-- <router-link
          :to="{ path: '/downloads' }"
          class="link_tab"
          :class="platform == 'downloads' ? 'act' : ''"
        >研究报告</router-link> -->
      </div>
      <a href="javascript:void(0);"></a>
      <div class="header_right">
        <!-- <div
          :class="screenfullState ? 'icon icon_full' : 'icon icon_full_c'"
          @click="fullScreen"
        > -->

        <el-popover
          offset="10"
          :width="368"
          placement="bottom"
          trigger="hover"
          popper-class="downPop"
        >
          <div class="down_list" v-if="downloadList && downloadList.length">
            <div class="download_item" v-for="(item,ind) in downloadList" :key="ind">
              <div class="download_item_info">
                <div class="download_item_name">
                  {{item.name}}
                </div>
                <div class="download_item_process_num">
                  {{downProcessList[ind]}}%
                </div>
              </div>
              <div class="download_item_controls">
                <div class="download_item_process_bar">
                  <el-progress :show-text="false" :percentage="downProcessList[ind]"/>
                </div>
                <div class="download_item_reload" @click="down_fn(ind)"></div>
              </div>
            </div>
          </div>
          <div class="down_no" v-else>暂无下载~</div>
           <template #reference>
            <div
              class="icon icon_download"
              :class="downloadList && downloadList.length ? 'has_new' : ''"
            ></div>
          </template>
        </el-popover>



        <el-popover
          offset="10"
          :width="335"
          placement="bottom"
          trigger="click"
          popper-class="msgPop"
        >
          <div class="msg_list" v-if="msgList && msgList.length">
            <el-popover
              v-for="item in msgList"
              :key="item.id"
              placement="left"
              :width="450"
              trigger="hover"
            >
              <template #reference>
                <div class="msg_item">
                  <div class="msg_tit">{{ item.msg }}</div>
                  <div class="msg_content">
                    <div class="msg_content_left">
                      {{ item.content }}
                    </div>
                    <div
                      class="msg_content_read"
                      @click="readMsgFn(item)"
                    ></div>
                  </div>
                  <div class="msg_time">{{ item.create_time }}</div>
                </div>
              </template>
              <div class="pop_item">
                <div class="pop_tit">
                  {{ item.msg }}
                </div>
                <div class="pop_content">
                  {{ item.content }}
                </div>
              </div>
            </el-popover>
          </div>
          <div class="msg_no_new" v-else>暂无新消息~</div>
          <template #reference>
            <div
              class="icon icon_msg"
              :class="msgList && msgList.length ? 'has_new' : ''"
            ></div>
          </template>
        </el-popover>

        <div
          class="icon icon_edit"
          @click="feedbackShow = true"
          v-if="userinfo.username"
        >
        </div>

        <el-popover
          offset="10"
          placement="bottom"
          :width="320"
          trigger="click"
          v-model:visible="isShowPerson"
          popper-class="infoPop"
        >
          <div class="setArea">
            <!-- <div class="setMoible">
              {{ userinfo.username }}
              <el-popover
                offset="10"
                placement="bottom"
                :width="330"
                trigger="click"
                v-model:visible="isShowUsernamePop"
                popper-class="setUsernamePop"
              >
                <div class="setArea">
                  <div class="currentUsername">
                    当前用户名：{{ userinfo.username }}
                  </div>
                  <div class="usernameInput">
                    <el-input
                      v-model="usernameInput"
                      input-style="border-radius:24px;width: 285px;height: 40px;background: #F6F9FD;"
                    />
                  </div>

                  <div class="setUsernameButton">
                    <div class="cancelButton" @click="isShowUsernamePop = false">
                      取消
                    </div>
                    <div class="confirmButton" @click="updateUsername">修改</div>
                  </div>
                </div>
                <template #reference>
                  <div class="editIcon"></div>
                </template>
              </el-popover>
            </div> -->
            <!-- <div class="setAccount">
              <div class="setRow">
                <div class="setLeft">登录账号</div>
                <div class="setRight">
                  {{ userinfo.mobile }}
                  <el-popover
                    offset="10"
                    placement="left-start"
                    :width="320"
                    trigger="click"
                    v-model:visible="isShowMobilePop"
                    popper-class="setMobilePop"
                  >
                    <div class="setArea">
                      <div class="currentUsername">当前手机号：{{ userinfo.mobile }}</div>
                      <div class="usernameInput">
                        <el-input
                          v-model="mobileInput"
                          placeholder="手机号"
                          input-style="border-radius:24px;width: 100%;height: 40px;background: #F6F9FD;"
                        />
                        <div class="inputZw"></div>
                        <el-input
                          v-model="codeInput"
                          placeholder="验证码"
                          input-style="border-top-left-radius: 24px;border-bottom-left-radius: 24px;width: 100%;height: 40px;background: #F6F9FD;"
                        >
                          <template #append>
                            <div
                              class="sendButton"
                              v-if="countDown.isFinished"
                              @click="getMobileCode"
                            >
                              发送验证码
                            </div>
                            <div class="sendButton" v-else>
                              重新获取({{ countDown.duration }}s)
                            </div>
                          </template>
                        </el-input>
                      </div>

                      <div class="setUsernameButton">
                        <div class="cancelButton" @click="isShowMobilePop = false">
                          取消
                        </div>
                        <div class="confirmButton" @click="updateMobile">修改</div>
                      </div>
                    </div>
                    <template #reference>
                      <div class="editIcon"></div>
                    </template>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="setExpire">
              <div class="setRow">
                <div class="setLeft">服务到期时间</div>
                <div class="setRight">{{ userinfo.failure_date }}</div>
              </div>
            </div> -->
            <div class="user_name_desc">
              <div class="user_name_text">{{ userinfo.username }}</div>
              <div class="user_name_tel">{{ userinfo.mobile }}</div>
            </div>
            <router-link
              class="user_setting_btn"
              @click="isShowPerson = false"
              :to="{
                path: '/setting',
                query: {
                  mode: 1,
                },
              }"
            >
              <span>个人设置</span>
              <span class="user_setting_icon"></span>
            </router-link>
            <router-link
              @click="isShowPerson = false"
              v-if="userinfo.role_id <= 2"
              class="user_setting_btn"
              :to="{
                path: '/setting',
                query: {
                  mode: 2,
                },
              }"
            >
              <span>企业设置</span>
              <span class="user_setting_icon"></span>
            </router-link>
            <div class="signOutBtn" @click="logout"><span>退出登录</span></div>
          </div>
          <template #reference>
            <div class="user_welcome">
              <div class="user_img">
                <img
                  src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/avatar_20230131.png"
                />
              </div>
              <div class="wel_text">{{ user_name }}</div>
              <div class="icon_down" v-if="userinfo.username"></div>
            </div>
          </template>
        </el-popover>
      </div>
    </div>
    <!-- 意见反馈弹窗 -->
    <el-dialog
      :append-to-body="true"
      v-model="feedbackShow"
      width="30%"
      title="意见反馈"
    >
      <div class="feed_back_pop">
        <div class="dialogText">
          <span style="color: red">*</span>
          问题描述
        </div>
        <div class="textareaBg">
          <textarea
            class="feedbackTextarea"
            v-model="feedbackContent"
            placeholder="请描述您反馈的内容或遇到的问题"
          ></textarea>
        </div>

        <div class="dialogText">联系方式</div>
        <div class="inputBg">
          <input
            class="feedbackInput"
            v-model="feedbackMobile"
            placeholder="请输入手机号"
          />
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="feedbackShow = false">取消</el-button>
          <el-button type="primary" @click="submitFeedback">提交</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { getCookie } from "@/plugins/cookie";
import store from "@/store";
import { ref, reactive, watch, computed} from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  ElPopover,
  // ElInput,
  ElDialog,
  ElMessage,
  ElProgress
} from "element-plus";
import {
  loginGetMobileCode,
  updateUserInfo,
  getMsgList,
  feedback,
  getUserInfo,
  readMsg,
  logoutApi
} from "@/api";
// import screenfull from "@/components/common/js/screenfull";
export default {
  name: "TheHeader",
  components: {
    ElPopover,
    // ElInput,
    ElDialog,
    ElProgress
  },
  setup() {
    // const isShowSetPop = ref(false);
    const isShowUsernamePop = ref(false);
    const isShowPerson = ref(false);
    const isShowMobilePop = ref(false);
    const router = useRouter();
    const route = useRoute();
    const userinfo = ref({});
    const mobileInput = ref("");
    const codeInput = ref("");
    const usernameInput = ref("");
    const msgList = ref([]);
    const failure_day = ref("");
    const showTry = ref(false);
    const feedbackShow = ref(false);
    const feedbackMobile = ref("");
    const feedbackContent = ref("");
    const platform = ref("home");
    const user_name = ref(store.state.userInfo.username);
    // const downloadList = ref(store.state.downloadList);
    const downloadList = ref([]);
    const downProcessList = ref([]);
    const addDownList = computed(()=>store.state.addDownList);

    const down_fn = (ind)=>{
      console.log(downloadList,ind)
      downProcessList.value[ind] = 0;
      if( downloadList.value[ind].xhr){
         downloadList.value[ind].xhr.abort();
      }
      downloadList.value[ind].xhr = new XMLHttpRequest();
      downProcessList.value.push(0);
      downloadList.value[ind].xhr.open('GET', downloadList.value[ind].url, true);
      downloadList.value[ind].xhr.responseType = 'blob'; // 接收二进制数据
      downloadList.value[ind].xhr.onload = function() {
        if (downloadList.value[ind].xhr.status === 200) {
          const blob = downloadList.value[ind].xhr.response;
          downloadList.value[ind].a_tag = document.createElement('a');
          downloadList.value[ind].a_tag.href = URL.createObjectURL(blob);
          downloadList.value[ind].a_tag.download = downloadList.value[ind].name;
          downloadList.value[ind].a_tag.style.display = 'none';
          document.body.appendChild(downloadList.value[ind].a_tag);
          downloadList.value[ind].a_tag.click();
          document.body.removeChild(downloadList.value[ind].a_tag);
          
        }
      };
      downloadList.value[ind].xhr.onprogress = function(event) {
        if (event.lengthComputable) {
          const total = event.total;
          const loaded = event.loaded;

          // downloadList.value[ind].progress = Math.round((loaded / total) * 100);
          downProcessList.value[ind]=Math.round((loaded / total) * 100);

        }
      };
      downloadList.value[ind].xhr.send();
    }

    watch(
      addDownList,
      (new_val)=>{
        JSON.parse(JSON.stringify(new_val)).forEach(down_item=>{
          downloadList.value.push(down_item);
          let downProcessInd = downloadList.value.length-1;
          down_fn(downProcessInd);
        })
      },
      {deep:true}
    )

    
       


    watch(
      () => store.state.userInfo,
      (new_val) => {
        if (new_val) {
          user_name.value = new_val.username;
        }
      }
    );
    watch(
      () => route.path,
      (new_val) => {
        getPlatformFn(new_val);
      }
    );
    const getPlatformFn = (new_val) => {
      if (new_val.indexOf("home") > -1) {
        platform.value = "home";
      } else if (new_val.indexOf("drive") > -1) {
        platform.value = "drive";
      } else if (new_val.indexOf("service") > -1) {
        platform.value = "service";
      } else if (new_val.indexOf("v2") > -1) {
        platform.value = "v2";
      } else {
        platform.value = "cockpit";
      }
    };
    getPlatformFn(route.path);
    const setUserInfo = () => {
      userinfo.value.username = getCookie("username");
      userinfo.value.mobile = getCookie("mobile");
      userinfo.value.failure_date = getCookie("failure_date");
      userinfo.value.role_id = getCookie("role_id");
    };
    setUserInfo();
    const showSetPop = () => {
      isShowPerson.value = false;
      document.getElementById("showSetButton").click();
    };
    const toPage = (url) => {
      router.push(url);
    };
    const logout = () => {
      logoutApi().then(res => {
        console.log(res)
        store.signOut();
        toPage("/login");
      })
      
    };
    // const showSetUsername = () => {
    //   isShowSetPop.value = false;
    //   document.getElementById("setUsername").click();
    // };
    // const showSetMobile = () => {
    //   isShowSetPop.value = false;
    //   document.getElementById("setMobile").click();
    // };

    const countDown = reactive({
        timer: null,
        duration: 60,
        isFinished: true,
      }),
      telreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      mobileCodereg = /^\d{6}$/,
      getMobileCode = () => {
        if (!countDown.isFinished) {
          return;
        }
        if (!mobileInput.value) {
          ElMessage.error("请输入手机号!");
          return false;
        }
        if (!telreg.test(mobileInput.value)) {
          ElMessage.error("请输入正确的手机号码!");
          return false;
        }
        countDown.timer && clearInterval(countDown.timer);
        countDown.isFinished = false;
        countDown.timer = setInterval(() => {
          const time = countDown.duration--;
          if (time <= 0) {
            clearInterval(countDown.timer);
            countDown.duration = 60;
            countDown.isFinished = true;
          }
        }, 1000);

        loginGetMobileCode({
          mobile: mobileInput.value,
        })
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("发送成功!");
            } else {
              ElMessage.error(res.message || "获取验证码失败，请稍后重试!");
              countDown.timer && clearInterval(countDown.timer);
              countDown.duration = 60;
              countDown.isFinished = true;
            }
          })
          .catch(() => {
            ElMessage.error("获取验证码失败，请重试!");
            countDown.timer && clearInterval(countDown.timer);
            countDown.duration = 60;
            countDown.isFinished = true;
          });
      };

    const updateUsername = () => {
      if (usernameInput.value == "") {
        ElMessage.error("用户名不可为空!");
        return false;
      }
      updateUserInfo({ username: usernameInput.value }).then((res) => {
        if (res.code == 200) {
          ElMessage.success("修改成功!");
          store.updateCookie("username", usernameInput.value);
          userinfo.value.username = usernameInput.value;
          user_name.value = usernameInput.value;
          isShowUsernamePop.value = false;
        } else {
          ElMessage.error(res.message || "修改失败!");
        }
      });
    };

    const updateMobile = () => {
      if (!mobileInput.value) {
        ElMessage.error("请输入手机号!");
      }
      if (!telreg.test(mobileInput.value)) {
        ElMessage.error("请输入正确的手机号码!");
        return false;
      }
      if (!codeInput.value) {
        ElMessage.error("请输入验证码!");
        return false;
      }
      if (!mobileCodereg.test(codeInput.value)) {
        ElMessage.error("请输入六位数字的验证码!");
        return false;
      }
      updateUserInfo({ mobile: mobileInput.value, code: codeInput.value }).then(
        (res) => {
          if (res.code == 200) {
            ElMessage.success("修改成功!");
            store.updateCookie("mobile", mobileInput.value);
            userinfo.value.mobile = mobileInput.value;
            isShowMobilePop.value = false;
          } else {
            ElMessage.error(res.message || "修改失败!");
          }
        }
      );
    };

    const refreshMsg = () => {
      getMsgList().then((res) => {
        msgList.value = res.data;
      });
    };
    refreshMsg();

    let timeObj = null;
    const getFailureDay = (enterprise_status) => {
      if (enterprise_status != 1) {
        let remainS =
          new Date(getCookie("failure_date") + " 23:59:59").getTime() -
          Date.now();
        if (remainS < 0) {
          failure_day.value = 1;
        } else {
          failure_day.value = Math.ceil(remainS / 86400000);
        }
        today_look();
      }
    };

    const today_look = () => {
      const look_time = getCookie("zn_look_time");
      if (
        !(
          look_time &&
          new Date(Number(look_time)).toDateString() ===
            new Date().toDateString()
        )
      ) {
        store.updateCookie("zn_look_time", new Date() * 1);
        showTry.value = true;
        timeObj = setTimeout(() => {
          showTry.value = false;
          clearTimeout(timeObj);
          timeObj = null;
        }, 30000);
      }
    };

    const submitFeedback = () => {
      if (feedbackContent.value != "") {
        feedback({
          content: feedbackContent.value,
          mobile: feedbackMobile.value,
        }).then((res) => {
          if (res.code == 200) {
            ElMessage.success("反馈成功!");
            feedbackMobile.value = "";
            feedbackContent.value = "";
            feedbackShow.value = false;
          } else {
            ElMessage.error(res.message || "反馈失败!");
          }
        });
      }
    };

    const _getUserInfo = () => {
      getUserInfo().then((res) => {
        store.updateCookie("role_id", res.data.role_id);
        store.updateCookie("failure_date", res.data.failure_date);
        store.checkLeafHide("zc", res.data.has_review_hide);
        store.checkLeafHide("js", res.data.has_intelligent_hide);
        store.state.download_content = res.data.download_content;
        userinfo.value.mobile = res.data.mobile;
        getFailureDay(res.data.enterprise_status);
      });
    };

    _getUserInfo();
    // const screenfullState = ref(true);
    // const fullScreen = () => {
    //   if (screenfull.enabled) {
    //     ElMessage.warning("您的浏览器不支持全屏！");
    //     return false;
    //   }
    //   screenfullState.value = screenfull.isFullscreen;
    //   screenfull.toggle();
    // };

    const readMsgFn = (data) => {
      console.log(data);
      readMsg({
        msg_id: data.id,
      }).then((res) => {
        if (res && res.code && res.code == 200) {
          const oldMsgList = msgList.value;
          let newMsgList = [];
          oldMsgList.forEach((item) => {
            if (item.id != data.id) {
              newMsgList.push(item);
            }
          });
          msgList.value = newMsgList;
        }
      });
    };

    return {
      userinfo,
      showSetPop,
      toPage,
      logout,
      // showSetUsername,
      // isShowSetPop,
      isShowUsernamePop,
      // showSetMobile,
      isShowPerson,
      isShowMobilePop,
      getMobileCode,
      mobileInput,
      countDown,
      usernameInput,
      updateUsername,
      updateMobile,
      codeInput,
      refreshMsg,
      msgList,
      failure_day,
      showTry,
      feedbackShow,
      submitFeedback,
      feedbackMobile,
      feedbackContent,
      // fullScreen,
      // screenfullState,
      platform,
      readMsgFn,
      user_name,
      downloadList,
      downProcessList,
      down_fn
    };
  },
};
</script>


<style lang="less" scoped>
.header {
  width: 100%;
  min-width: 1290px;
  .tryArea {
    height: 50px;
    background-color: #f3d386;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    .tryIcon {
      width: 50px;
      color: white;
      background-color: #ff8383;
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 70px;
    }
    .tryText {
      margin-left: 10px;
    }
    .serviceTel {
      flex: 1;
      text-align: right;
      margin-right: 50px;
    }
  }
  .header_content {
    height: 76px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header_left {
      min-width: 350px;
      height: 100%;
      padding: 22px 0 0 30px;
      .header_logo {
        width: 278px;
        height: 29px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .header_center {
      flex-shrink: 0;
      min-width: 560px;
      display: flex;
      justify-content: center;
      align-items: center;
      .link_tab {
        width: 180px;
        text-align: center;
        font-size: 17px;
        color: #36474f;
        letter-spacing: 1px;
        text-decoration: none;
        position: relative;
        &::before {
          content: "";
          width: 1px;
          height: 20px;
          background: #ccc;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        &:first-child::before {
          content: "";
          width: 0;
          height: 0;
        }
        &.act {
          font-weight: 900;
          color: #1fbcbf;

          // &::before{
          //   content: "";
          //   width: 12px;
          //   height: 24px;
          //   background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/line_20221226.png) no-repeat center center;
          //   background-size: 100%;
          //   position: absolute;
          //   left: 0;
          //   top: 50%;
          //   transform: translate(-50%,-50%);
          // }
          // &::after{
          //   content: "";
          //   width: 12px;
          //   height: 24px;
          //   background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/line_20221226.png) no-repeat center center;
          //   background-size: 100%;
          //   position: absolute;
          //   right: 0;
          //   top: 50%;
          //   transform: translate(50%,-50%);
          // }
        }
        
        .new_badge {
          display: inline-block;
          width: 32px;
          height: 16px;
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/new_20230223.png) no-repeat center center;
          background-size: 100%;
          margin-left: 8px;
          vertical-align: text-top;
          transform: translateY(-2px);
        }
      }
    }
    .header_right {
      display: flex;
      align-items: center;
      .icon {
        cursor: pointer;
        width: 30px;
        height: 30px;
        margin-right: 30px;
        &.icon_msg {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/msg_20221226.png)
            no-repeat center center;
          background-size: 23px 26px;
          &.has_new {
            position: relative;
            &::after {
              content: "";
              width: 10px;
              height: 10px;
              background: #f00;
              border-radius: 5px;
              position: absolute;
              top: 3px;
              right: 3px;
            }
          }
        }
        &.icon_full {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/full_20221226.png)
            no-repeat center center;
          background-size: 20px 20px;
        }
        &.icon_full_c {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/full_c_20221226.png)
            no-repeat center center;
          background-size: 20px 20px;
        }
        &.icon_download {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/down_20230404.png)
            no-repeat center center;
          background-size: 24px 24px;
          &.has_new {
            position: relative;
            &::after {
              content: "";
              width: 10px;
              height: 10px;
              background: #f00;
              border-radius: 5px;
              position: absolute;
              top: 0px;
              right: 0px;
            }
          }
        }
        &.icon_edit {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/edit_20221226.png)
            no-repeat center center;
          background-size: 21px 20px;
        }
      }
      .user_welcome {
        display: flex;
        align-items: center;
        margin-right: 30px;
        cursor: pointer;
        .user_img {
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .wel_text {
          margin-left: 12px;
          font-size: 14px;
          color: #36474f;
        }
        .icon_down {
          width: 38px;
          height: 38px;
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/down_20221226.png)
            no-repeat center center;
          background-size: 12px 8px;
        }
      }
    }
  }
}
.feed_back_pop {
  .dialogText {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .textareaBg {
    height: 200px;
    background-color: rgb(246, 249, 253);
    margin-bottom: 10px;
    .feedbackTextarea {
      width: 100%;
      height: 100%;
      resize: none;
      padding: 10px;
      background-color: rgb(246, 249, 253);
      border-color: rgb(246, 249, 253);
      outline: none;
    }
  }
  .inputBg {
    height: 40px;
    background-color: rgb(246, 249, 253);
    margin-bottom: 10px;
    .feedbackInput {
      width: 100%;
      height: 100%;
      padding: 5px;
      background-color: rgb(246, 249, 253);
      border: none;
      outline: none;
    }
  }
}

.infoPop {
  width: 300px;
  box-shadow: 12px 11px 45px 0px rgba(208, 224, 246, 0.41);
  border-radius: 14px;
  border: 1px solid #d8e2f0;
  padding-bottom: 10px;
  .setArea {
    padding: 0px 27px 10px;
    .setMoible {
      height: 26px;
      font-size: 18px;
      font-weight: bold;
      color: #666666;
      line-height: 26px;
      margin-top: 15px;
      margin-bottom: 13px;
      display: flex;
      align-items: center;
    }
    .editIcon {
      width: 12px;
      height: 12px;
      margin-left: 14px;
      background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/bj.png);
      background-size: 100%;
      cursor: pointer;
    }
    .setAccount {
      margin-top: 28px;
    }
    .setExpire {
      margin-top: 22px;
    }
    .setRow {
      display: flex;
      justify-content: space-between;
    }
    .setLeft {
      font-size: 15px;
      font-weight: 400;
      color: #999;
      line-height: 21px;
    }
    .setRight {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      line-height: 21px;
    }
    .signOutBtn {
      margin-top: 22px;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      background: #fd8f8f;
      color: #fff;
    }
  }
}
.setArea {
  padding: 0 10px 20px;
}
.currentUsername {
  width: 200px;
  height: 21px;
  font-size: 16px;
  color: #464646;
  line-height: 21px;
  margin-top: 30px;
}
.usernameInput {
  margin-top: 27px;
}
.inputZw {
  margin-top: 14px;
}
.sendButton {
  width: 35%;
  font-size: 14px;
  font-weight: 400;
  color: #3f8fff;
  line-height: 20px;
  cursor: pointer;
}
.cancelButton {
  width: 84px;
  height: 35px;
  background: #b4b9bf;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.confirmButton {
  margin-left: 13px;
  width: 84px;
  height: 35px;
  background: #1fbcbf;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.setUsernameButton {
  margin-top: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.setUsernamePop {
  height: 225px;
  box-shadow: 12px 11px 45px 0px rgba(208, 224, 246, 0.41);
  border-radius: 14px;
  border: 1px solid #d8e2f0;
  padding: 40px;
}

.msg_list {
  width: 312px;
  height: 336px;
  overflow-y: auto;
  padding: 15px 0 0;
  .msg_item {
    padding: 14px 15px;
    &:hover {
      background: #f9f9f9;
      opacity: 0.5;
    }
    .msg_tit {
      font-size: 14px;
      font-weight: bold;
      color: #313131;
      line-height: 20px;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .msg_content {
      margin-top: 6px;
      padding-top: 6px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #d8e2f0;
      .msg_content_left {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        width: calc(100% - 30px);
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .msg_content_read {
        cursor: pointer;
        width: 20px;
        height: 20px;
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/close_20230103.png)
          no-repeat center center;
        background-size: 8px;
      }
    }
    .msg_time {
      margin-top: 9px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }
}
.msg_no_new {
  text-align: center;
}
.el-popover .pop_item {
  padding: 10px;
  .pop_tit {
    font-size: 16px;
    font-weight: bold;
    color: #313131;
    line-height: 22px;
    text-align: center;
  }
  .pop_content {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    white-space: pre-line;
  }
}
:deep(.el-input .el-input-group__append) {
  border-radius: 0 24px 24px 0;
}

.user_name_desc {
  display: flex;
  align-items: center;
  padding: 10px 0;
  .user_name_text {
    font-size: 18px;
    color: #272727;
  }
  .user_name_tel {
    margin-left: 18px;
    font-size: 14px;
    font-weight: 400;
    color: #a4a7ad;
  }
}
.user_setting_btn {
  margin: 10px auto;
  width: 252px;
  height: 39px;
  background: #f7f7f7;
  border-radius: 2px;
  padding: 0 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
  }
  .user_setting_icon {
    width: 15px;
    height: 15px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/right_20230106.png)
      no-repeat center center;
    background-size: 6px;
  }
}

.down_list{
  width: 344px;
  padding: 10px;
  margin: 0 auto;
  max-height: 500px;
  overflow-y: auto;
  .download_item{
    width: 100%;
    padding: 14px 0;
    .download_item_info{
      width:302px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .download_item_name{
        color:#828282;
        font-size: 12px;
        line-height: 14px;
        width: 250px;
      }
      .download_item_process_num{
        color:#738792;
        font-size: 12px;
      }
    }
    .download_item_controls{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 11px;
        margin-top: 5px;
      .download_item_process_bar{
        width: 302px;
      }
      .download_item_reload{
        width: 11px;
        height: 11px;
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/reload_20230406.png) no-repeat center center;
        background-size: 100%;
      }
    }
  }
}
.down_no{
  text-align: center;
}
</style>